import {
  createNgReactBridgeController,
  createNgReactBridgeFactory
} from '../../react-bridge'
import { DashboardToggleService } from './dashboard-toggle.service'
import {
  DashboardSwitchCtrl,
  NewDashboardCtrl,
  DashboardCtrl
} from './dashboard.controller'

createNgReactBridgeController('DashboardSwitchCtrl', DashboardSwitchCtrl)
createNgReactBridgeController('NewDashboardCtrl', NewDashboardCtrl)
createNgReactBridgeController('DashboardCtrl', DashboardCtrl)
createNgReactBridgeFactory('dashboardToggleService', DashboardToggleService)
